<template>
  <span :aria-label="label" class="ew-dots" role="img" :title="label">
    <span v-for="dot in dots" :key="dot.key" :class="`ew-dot--${dot.tone}`" class="ew-dot">{{ dot.short }}</span>
    <span v-if="!dots.length" class="acq-tiny">–</span>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {AbsenceEarlyWarningRecentItem} from '@/documentTypes/workflow-manager/AbsenceEarlyWarningRecord.document';
import {PresenceDot, presenceDots, presenceDotsLabel} from '@/components/earlyWarning/earlyWarning.helper';

/** Evaluated lessons as A/E/U dots, oldest first (anwesend / entschuldigt / unentschuldigt) */
export default Vue.extend({
  props: {
    recent: {type: Array as () => AbsenceEarlyWarningRecentItem[], default: () => []},
    /** Alternative: ready-made dots (e.g. from the letters of a log entry) */
    items: {type: Array as () => PresenceDot[] | null, default: null},
  },
  computed: {
    dots(): PresenceDot[] {
      return this.items || presenceDots(this.recent);
    },
    label(): string {
      return presenceDotsLabel(this.dots);
    },
  },
});
</script>

<style scoped>
.ew-dots {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 3px;
  vertical-align: middle;
}

.ew-dot {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  display: inline-grid;
  place-items: center;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  color: #FFFFFF;
}

.ew-dot--good {
  background: #2E7D32;
}

.ew-dot--warn {
  background: #B26A00;
}

.ew-dot--bad {
  background: #C62828;
}

.ew-dot--muted {
  background: rgba(15, 23, 42, .2);
  color: rgba(15, 23, 42, .7);
}

.theme--dark .ew-dot--good {
  background: #43A047;
}

.theme--dark .ew-dot--warn {
  background: #F0A030;
  color: #1E1E1E;
}

.theme--dark .ew-dot--bad {
  background: #E57373;
  color: #1E1E1E;
}
</style>
